module.exports = __webpack_public_path__ + "img/4.94cffb2c.png";